<template>
    <div :id="'LqsAnalyser' + asinData" v-if="viewLqsGraph">
        <div class="container-fluid" style="padding: 0px !important">
            <!-- <ASINResult/> -->
            <div style="margin: 0">
                <!-- <div style="margin: 0; padding-bottom: 0 !important" class="graphHeading">
                    Listing Quality Score (LQS) Analysis
                </div> -->
                <div style="margin: 0; padding-bottom: 0 !important" class="mainHeading d-flex justify-content-end">
                    <span style="color: var(--primary_brand); font-size: 16px">{{
                        timestamp
                    }}</span>
                    <span class="ml-2 screenshot-btn" @click="takeScreenshot"><i
                            class="fa fa-download cursor-pointer text-primary bg-black px-2 py-1 border border-success rounded"
                            aria-hidden="true"></i>
                    </span>
                </div>
            </div>
            <div class="row p-2">
                <div class="productCart">
                    <div class="productImg">
                        <img :src="viewLqsListingdata.product_meta.product_image" crossorigin="anonymous" />
                    </div>
                    <div class="ml-2">
                        <a :href="viewLqsListingdata.product_meta.product_link" target="_blanck"
                            class="cursor-pointer textColor product-title" syte>{{
                                viewLqsListingdata.product_meta.product_name }} <span v-if="asinData"
                                style="font-weight:bold">({{ asinData }})</span></a>
                    </div>
                </div>
            </div>
            <div class="row p-2">
                <div class="col-3">
                    <div class="border rounded">
                        <div style="text-align: center">
                            <highcharts :options="gaugeChartData"></highcharts>
                        </div>
                        <div class="text-center graphCount">{{ viewLqsGraph }}</div>
                    </div>
                </div>
                <div class="col-9">
                    <div class="row">
                        <div class="col sideBorder">
                            <div class="secondaryHeading mb-2">Copy Breakdown</div>
                            <div class="space-between-header" v-for="(row, i) in viewLqsListingdata.copy_breakdown"
                                :key="'lqs_cb' + i">
                                <div class="textColor" style="text-transform: capitalize">
                                    <i class="fa fa-circle trueIcon mr-2" aria-hidden="true"
                                        :class="{ falseIcon: row.status == false }"></i>
                                    {{ row.label }}
                                    <i class="fa fa-info-circle cursor-pointer" aria-hidden="true" :title="row.label"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col sideBorder">
                            <div class="secondaryHeading mb-2">Media Breakdown</div>
                            <div class="space-between-header" v-for="(row, i) in viewLqsListingdata.media_breakdown"
                                :key="'lqs_cb' + i">
                                <div class="textColor" style="text-transform: capitalize">
                                    <i class="fa fa-circle trueIcon mr-2" aria-hidden="true"
                                        :class="{ falseIcon: row.status == false }"></i>
                                    {{ row.label }}
                                    <i class="fa fa-info-circle cursor-pointer" aria-hidden="true" :title="row.label"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="secondaryHeading mb-2">Review Breakdown</div>
                            <div class="space-between-header" v-for="(row, i) in viewLqsListingdata.review_breakdown"
                                :key="'lqs_cb' + i">
                                <div class="textColor" style="text-transform: capitalize">
                                    <i class="fa fa-circle trueIcon mr-2" aria-hidden="true"
                                        :class="{ falseIcon: row.status == false }"></i>
                                    {{ row.label }}
                                    <i class="fa fa-info-circle cursor-pointer" aria-hidden="true" :title="row.label"></i>
                                </div>
                            </div>
                            <div class="singatureLogo">
                                <div style="font-size: 14px" class="text-secondary">Powered By</div>
                                <img src="img/brand/brand_logos/Logos-18.png" width="72" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="row p-0">
                <div class="col-12 d-flex justify-content-end">
                    <div style="margin: 0; padding-bottom: 0 !important" class="mainHeading d-flex align-items-center flex-column">
                        <span style="font-size: 15px" class="text-secondary mr-2">Powered By</span>
                        <img src="img/brand/brand_logos/Logos-18.png" width="72"/>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import html2canvas from 'html2canvas';

export default {
    name: "LqsCard",
    props: ["viewLqsListingdata", "viewLqsGraph", "timestamp", "asinData"],

    data: function () {
        return {
            gaugeChartData: {},
            inputSearchkey: "",
            loader: false,
            asin: "",
        };
    },
    watch: {},

    mounted() {
        this.gaugeChart();
    },
    methods: {
        async takeScreenshot() {
            let self = this
            let id = "#LqsAnalyser" + this.asinData;
            let uniqueCardId = document.querySelector(id);
            let getScreenshotDiv = uniqueCardId.querySelector('.screenshot-btn');
            getScreenshotDiv.classList.add('screenshot-hide-btn');
            html2canvas(uniqueCardId, { useCORS: true }).then(function (canvas) {
                canvas.style.display = "none"
                document.body.appendChild(canvas);
                const image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
                const a = document.createElement("a");
                a.setAttribute("download", `Weavr-LQS-${ self.asinData }.png`);
                a.setAttribute("href", image);
                a.click();
                getScreenshotDiv.classList.remove('screenshot-hide-btn');
            });
        },
        chartHeight() {
            if (window.screen.width < 1400) {
                return 200
            }
            else
                return 250
        },
        chartSize() {
            if (window.screen.width < 1400) {
                return 280
            }
            else
                return 400
        },
        gaugeChart() {
            let self = this;
            this.gaugeChartData = {
                chart: {
                    type: "gauge",
                    plotBackgroundImage: null,
                    height: this.chartHeight(),
                },

                title: {
                    text: "Listing Quality Score ",
                },
                credits: {
                    enabled: false,
                },
                pane: [
                    {
                        startAngle: -45,
                        endAngle: 45,
                        background: null,
                        center: ["50%", "120%"],
                        size: this.chartSize(),
                    },
                ],

                exporting: {
                    enabled: false,
                },

                tooltip: {
                    enabled: false,
                },

                yAxis: [
                    {
                        min: 0,
                        max: 10,
                        minorTickPosition: "outside",
                        tickPosition: "outside",
                        labels: {
                            rotation: "auto",
                            distance: 10,
                        },
                        plotBands: [
                            {
                                from: 0,
                                to: 10,
                                color: {
                                    stops: [
                                        [0, "#fd6b2d"], //yellow
                                        [1, "#55BF3B"], //green
                                    ],
                                },
                                innerRadius: "90%",
                                outerRadius: "100%",
                            },
                            {
                                from: 0,
                                to: 4,
                                color: "#FF786B", // red
                                thickness: 20,
                            },
                            {
                                from: 4,
                                to: 8,
                                color: "#667BFE", // blue
                                thickness: 20,
                            },
                            {
                                from: 8,
                                to: 10,
                                color: "#42D9BC", // green
                                thickness: 20,
                            },
                        ],
                        pane: 0,
                        title: {
                            text: "",
                            y: 0,
                        },
                    },
                ],

                plotOptions: {
                    gauge: {
                        dataLabels: {
                            enabled: false,
                        },
                        dial: {
                            radius: "100%",
                        },
                    },
                },

                series: [
                    {
                        name: "Ratting",
                        data: [self.viewLqsGraph],
                        yAxis: 0,
                    },
                ],
            };
        },
    },
};
</script>

<style scoped>
.space-between {
    display: flex;
    justify-content: space-between;
}

.cursor-pointer {
    cursor: pointer;
}

.flex-start {
    display: flex;
    justify-content: start;
}

.mainHeading {
    color: #4e4e4e;
    margin-bottom: 0;
    font-size: 1.3125rem;
}

.secondaryHeading {
    color: #4e4e4e;
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: bold;
}

.textColor {
    color: #818890 !important;
}

.flex-start {
    display: flex;
    justify-content: flex-start;
}

.inputBox {
    height: 30px;
    border: 1px solid silver;
    display: flex;
    justify-content: start;
    background: white;
}

.inputBox input {
    border-radius: 0px;
    border: none !important;
}

.sideBorder {
    border-right: 1px solid #c1c1c1;
}

input:focus {
    outline: none !important;
    box-shadow: none !important;
}

.trueIcon {
    color: #64ac94 !important;
}

.falseIcon {
    color: #ff0000 !important;
}

.cardButton {
    margin-left: 10px;
}

.productCart {
    display: flex;
    justify-content: space-between;
    padding: 10px;
}

.productImg {
    width: 200px;
}

.product-title {
    font-size: 18px;
}

.productImg img {
    max-width: 60%;
    height: 100%;
}

.graphCount {
    font-size: 24px;
    color: "#533a79";
    font-weight: 700;
}

.asinBadge {
    /* background: '#9683b3'; */
    background: "#9683b3";
}

.cross-icon {
    color: black;
    background: white;
}

.crossIcon {
    cursor: pointer;
    font-size: 8px;
}

.space-between {
    display: flex;
    justify-content: space-between;
}

thead {
    background: none;
    font-family: sans-serif;
    background: #9683b3;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    /* padding: 10px; */
}

tbody {
    font-family: sans-serif;
    font-size: 13px;
}

.pinkColor {
    background: rgb(255 185 185);
    font-weight: bold;
}

.skyColor {
    background: rgb(199 224 255);
    font-weight: bold;
}

.no-data {
    font-size: 16px;
    text-align: center;
    padding: 10px;
    color: red;
}

.card {
    border-radius: 0.7rem !important;
    border: none !important;
    margin-bottom: 1rem;
}

.graphHeading {
    font-weight: 600 !important;
    font-size: 20px !important;
    color: var(--primary_brand) !important;
    letter-spacing: 0.6px !important;
    font-family: "poppins";
}

#LqsAnalyser {
    font-family: "poppins" !important;
}

.singatureLogo {
    position: absolute;
    bottom: 20px;
    right: 20px;
    text-align: center !important;
}

.screenshot-btn{
    transition: .4s linear !important;
}

.screenshot-btn .fa-download {
    color: var(--primary_brand) !important
}

.screenshot-btn:hover {
    background-color: #F2F1F6;
}

.screenshot-hide-btn {
    visibility: hidden;
}

</style>
